import { React, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

import FetchModule from '../../../../Share/Network/FetchModule';

export default function LockerRefundDeleteModal(props) {
  const { data, rendering, onClickExit } = props;

  useEffect(() => {
    document.body.style= `overflow: hidden`;
    return () => document.body.style = `overflow: auto`
  }, [])

  function deleteClick() {
    if (data.merchantUid.split('-')[2] === '1'
    || data.merchantUid.split('-')[2] === '2') {
      alert('링크페이 환불내역은 삭제할 수 없습니다');
      return;
    }

    let requestData = {
      merchantUid: data.merchantUid
    }

		const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('sales/refund/delete', 'POST', requestData);

        if (responseData.status === 200) {
          rendering();
          onClickExit();
        }
        else {
          alert(responseData.error);
          onClickExit();
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <ModalView>
        <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#000000' cursor='default'>환불 내역 삭제</Text>
        <TextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959' cursor='default'>환불 내역 삭제를 진행합니다,</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959' cursor='default'>환불 내역 삭제를 진행하면 다시 되돌릴 수 없습니다.</Text>
        </TextWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickExit}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='pointer'>취소</Text>
          </ExitButton>
          <CancelButton onClick={deleteClick}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>삭제하기</Text>
          </CancelButton>
        </ButtonWrapper>
      </ModalView>
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);

	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 20px;

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 30px;

  gap: 8px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  gap: 16px;

  margin: 53px 0 0 153px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: #F5F6F8;

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const CancelButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #FF3131;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }
`;
